import { Box, CircularProgress, Grid, Stack, Typography, useTheme } from "@mui/material";
import { IReference } from "Common/Interfaces/Domain/Conversations";
import { PdfViewer } from "./PdfViewer";
import { ChatButton } from "Common/Components";
import { ArrowBackOutlined } from "@mui/icons-material";
import { useMatchDownMd } from "Common/Hooks";

interface IViewReference {
  onClick?: () => void;
  title?: string;
  reference?: IReference;
  initialPage: number;
  modifiedUrl: string | undefined;
  isLoading: boolean;
  pageResetKey: number | undefined;
  warningMessage?: string;
}

export const ViewReference = (props: IViewReference) => {
  const { onClick, reference, initialPage, modifiedUrl, isLoading, pageResetKey, warningMessage } = props;
  const theme = useTheme();
  const matchDownMd = useMatchDownMd();

  return (
    <Box sx={{ height: "100%", background: theme.palette.grey[100] }}>
      <Stack spacing={1} sx={{ px: matchDownMd ? 0 : 2, height: "100%" }}>
        <Grid container sx={{ alignItems: "center", xs: 12, pt: 1 }} spacing={2.5}>
          <Grid sx={{ xs: 1, pl: 1 }}>
            <ChatButton
              tooltipTitle="Back to list"
              hasBackground
              backgroundColor={theme.palette.grey[300]}
              Icon={ArrowBackOutlined}
              onClick={onClick}
            />
          </Grid>
          <Grid sx={{ width: "80%" }}>
            <Typography
              sx={(theme) => ({
                fontSize: theme.typography.pxToRem(16),
                fontWeight: theme.typography.fontWeightSemiBold,
                textTransform: "capitalize",
                wordWrap: "break-word",
              })}
            >
              {reference?.title}
            </Typography>
          </Grid>
        </Grid>

        {isLoading ? (
          <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <CircularProgress />
          </Box>
        ) : (
          <PdfViewer
            url={modifiedUrl}
            initialPage={initialPage}
            pageResetKey={pageResetKey}
            warningMessage={warningMessage}
          />
        )}
      </Stack>
    </Box>
  );
};
